import React, { createContext, useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const AuthReadyContext = createContext(true);

const ProtectedRoute = ({ user, allowedRoles, children }) => {
    const location = useLocation();
    const ready = useContext(AuthReadyContext);
    if (!ready) return <p role="status">Checking sign-in…</p>;
    if (!user) {
        const returnTo = location.pathname + location.search + location.hash;
        sessionStorage.setItem('loginReturnTo', returnTo);
        // If not logged in, redirect to the home page
        return <Navigate to="/" state={{ unauthorized: true, returnTo }} />;
    }

    if (allowedRoles && !allowedRoles.includes(user.role)) {
        // If the user's role is not in the list of allowed roles, redirect to the home page
        console.error('ProtectedRoute: User does not have the required role. Allowed:', allowedRoles, 'User role:', user.role);
        return <Navigate to="/" state={{ unauthorized: true }} />;
    }

    // If authorized, render the children
    return children;
};

export default ProtectedRoute;
